module.exports = __webpack_public_path__ + "img/dps1.88440607.jpg";